import React from "react";
import SavedMunis from "../components/SavedSeries";
import { UserAuth } from "../context/AuthContext";
import AuthorizedSeries from "../components/AuthorizedSeries";
import { useTranslation } from "../hooks/useTranslation";

const Account = () => {
  const { user } = UserAuth();
  const { t } = useTranslation();

  return (
    <>
      <div className="w-full text-white">
        <img
          className="w-full h-[400px] object-cover"
          src={`./background.jpg`}
          alt={t("accountBannerAlt")}
        ></img>

        <div className="bg-black/60 absolute top-0 left-0 w-full h-[400px]">
          <div className="absolute top-[20%] p-4 md:p-8"></div>
        </div>
        <h1 className="text-3xl md:text-5xl font-bold pl-4 py-4">
          {t("hello")}, {user.email}
        </h1>
        <div>
          <h2 className="pl-4 py-2">
            {t("accountSeeVideos")}{" "}
            <a className="text-blue-500" href="/">
              {t("home")}
            </a>{" "}
            {t("accountSavedFavourites")}
          </h2>
        </div>

        {/* Display authorized series */}
        <AuthorizedSeries />

        {/* Display saved series */}
        <div>
          <SavedMunis />
        </div>
      </div>
      <br></br>
    </>
  );
};

export default Account;
